import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { useIsMobileDevice } from '../../hooks';
import * as styles from './styles.css';

export const DealRentDepositHint: React.FC = () => {
  const isMobile = useIsMobileDevice();

  return (
    <div
      {...mergeStyles(
        styles['container'],
        !isMobile && styles['container-desktop'],
      )}
    >
      <div className={styles['description']}>
        Вы подключили сервис Сдай/Сними. Теперь ваша квартира сдаётся без
        залога, а вы получаете:
        <br />
        <span>•</span> Компенсацию простоя квартиры до 15 дней
        <br />
        <span>•</span> 70 000 Р на любой урон от арендатора
      </div>
      <a
        href="https://promo.cian.ru/sday-snimi-2"
        target="_blank"
        className={styles['link']}
      >
        Подробнее о сервисе
      </a>
      <div className={styles['info']}>
        Отключить сервис можно в Личном кабинете
      </div>
    </div>
  );
};
